import { type State } from './types';

export const getOpenDraws = ({ ui }: { ui: State }) => ui.openDraws;
